export const MAPBOX_GEOCODING_HOST = 'https://api.mapbox.com';

export const MAPBOX_REVERSE_GEOCODE_PATH = '/geocoding/v5/mapbox.places';

// Limit to the types most useful as a location label. Mapbox returns many
// overlapping features per coordinate — preferring address > street > place
// keeps the label recognizable without falling back to "United States".
export const PREFERRED_FEATURE_TYPES = ['address', 'street', 'place', 'neighborhood'];

// Region line derivation — the drawer shows a human-readable "city, state ZIP"
// line under the address. We prefer the first feature whose place_type includes
// one of these, in order.
export const REGION_FEATURE_TYPES = ['place', 'region', 'postcode'];

// Mapbox place_names frequently end with ", United States" for US coords. The
// drawer already implies United States context — drop the trailing country so
// the region reads "Portland, Oregon" instead of "Portland, Oregon, United States".
export const REGION_COUNTRY_SUFFIX = ', United States';
